import React, { Component } from "react";

import { Route, Switch } from "react-router-dom";

import ForgetPass from "./views/pages/forget";
import Page404 from "./views/pages/404";
import BackcountrySurvey from "./views/pages/backcountry_survey";
import BackcountryThanks from "./views/pages/backcountry_survey/thanks";

const AuthenticatedRoute = (props) => null;

// getComponent is a function that returns a promise for a component
// It will not be called until the first mount
function asyncComponent(getComponent) {
  return class AsyncComponent extends React.Component {
    static Component = null;
    state = { Component: AsyncComponent.Component };

    componentWillMount() {
      if (!this.state.Component) {
        getComponent().then((Component) => {
          AsyncComponent.Component = Component;
          this.setState({ Component });
        });
      }
    }
    render() {
      const { Component } = this.state;
      if (Component) {
        return <Component {...this.props} />;
      }
      return null;
    }
  };
}

const SignIn = asyncComponent(() =>
  import("./views/pages/signin").then((module) => module.default)
);

const ResetPassword = asyncComponent(() =>
  import("./views/pages/reset").then((module) => module.default)
);

const EmailUnsubscribe = asyncComponent(() =>
  import("./views/pages/unsubscribe").then((module) => module.default)
);
// const Exercises = asyncComponent(() =>
//     import("./views/exercises").then(module => module.default)
// );

// const Programming = asyncComponent(() =>
//     import("./views/programming").then(module => module.default)
// );

const New = asyncComponent(() =>
  import("./views/new").then((module) => module.default)
);

// const NewAthletes = asyncComponent(() =>
//     import("./views/new_athletes").then(module => module.default)
// );
// const Athletes = asyncComponent(() =>
//     import("./views/athletes").then(module => module.default)
// );
// const AppSettings = asyncComponent(() =>
//     import("./views/appsettings").then(module => module.default)
// );

class Routes extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route exact path="/login" component={SignIn} />

          <Route exact path="/" component={SignIn} />
          <Route path="/0" component={New} />

          {/*<Route component={AppBackup} path="/app">
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/appa/widgets" component={Widgets} />
            <Route path="/app/ui/buttons" component={Buttons} />
            <Route path="/app/ui/typography" component={Typography} />
            <Route path="/app/ui/cards" component={Cards} />
            <Route path="/app/ui/modals" component={Modals} />
            <Route path="/app/ui/notification" component={Notification} />
            <Route path="/app/ui/extras" component={Extras} />
            <Route path="/app/forms/general" component={FormGeneral} />
            <Route path="/app/forms/advanced" component={FormAdvanced} />
            <Route path="/app/charts" component={Charts} />
            <Route path="/app/tables" component={Tables} />
          </Route>*/}
          <Route component={ResetPassword} path="/password_reset/:token/" />
          <Route
            component={EmailUnsubscribe}
            path="/email_unsubscribe/:email/"
          />
          <Route component={BackcountrySurvey} path="/backcountry_survey" />
          <Route component={BackcountryThanks} path="/backcountry_thanks" />
          {/*<Route component={Mail} path="mail" />
                <Route component={SignIn} path="/login" />
                <Route component={Register} path="pages/register" />
                <Route component={ForgetPass} path="/pages/forget" />
                <Route component={Page404} path="pages/404" />
                <Route component={PageInvoice} path="pages/invoice" />*/}
          {/* default */}
          <Route component={ForgetPass} path="/pages/forget" />
          <Route component={Page404} path="404" />
          <Route component={Page404} />
        </Switch>
      </div>
    );
  }
}

export default Routes;
